import React, { useCallback } from 'react';

import { CellContext } from '@tanstack/react-table';

import ProtectedData, { isProtectedData } from 'pages/components/ProtectedData';

export default function useDefaultCellRenderer() {
    const render = useCallback(<P, V>(info: CellContext<P, V>) => {
        const value = info.getValue();
        if (isProtectedData(value)) {
            return <ProtectedData data={value} />;
        } else {
            return info.renderValue();
        }
    }, []);

    return render;
}
